export const plusCopy = {
  mn: {
    quickTitle: 'Plus эрхтэй хэрэглэгч болох',
    noSentOverlayTitle: 'Энэ мэдээлэл зөвхөн CV илгээсэн зард харагдана',
    quickSubtitleBefore:
      'Ажил горилогчдын нас, туршлага, ур чадвар, таны CV хэрхэн зохицож буйг ',
    quickSubtitleAfter: '-аар нээж үзээрэй',
    quickSubtitleBrand: 'Zangia Plus',
    overlayTitle: 'Энэ мэдээллийг зөвхөн Plus эрхтэй хэрэглэгч харах боломжтой',
    overlaySubtitle:
      'Горилогчдын нас, туршлага, ур чадвар, таны CV хэрхэн зохицож буйг Zangia Plus-аар нээгээд үзээрэй',
    activate: 'Plus эрх идэвхжүүлэх',
    introTitle: 'Zangia Plus-тай танилц',
    introSubtitle: 'Ажил горилохдоо давуу тал өгөх нэмэлт боломжууд',
    unlimited: 'Хязгааргүй',
    sale: 'Хямдралтай',
    monthly: 'Сарын багц',
    quarterly: '3 сарын багц',
    payTitle: 'Төлбөр төлөх',
    insufficientTitle: 'Үлдэгдэл хүрэлцэхгүй',
    payAmount: 'Төлбөрийн дүн:',
    totalBalance: 'Нийт үлдэгдэл:',
    remaining: 'Үлдэх дүн:',
    shortfall: 'Дутуу дүн:',
    main: 'Үндсэн',
    bonus: 'Бонус',
    cancel: 'Цуцлах',
    pay: 'Төлбөр төлөх',
    recharge: 'Данс цэнэглэх',
    paySuccess: 'Plus эрх амжилттай идэвхжлээ',
    settingsTitle: 'Zangia Plus эрх',
    settingsTab: 'Zangia Plus',
    active: 'Идэвхтэй',
    inactive: 'Идэвхгүй',
    expired: 'Дууссан',
    changePackage: 'Багц солих',
    extend: 'Эрх сунгах',
    purchasedOn: 'Худалдан авсан огноо',
    validUntil: 'Хүчинтэй хугацаа',
    validUntilSuffix: 'хүртэл',
    remainingTime: 'Үлдсэн хугацаа',
    remainingDays: 'хоног',
    ofDays: 'хоногоос',
    endsAt: '23:59 цагт дуусна',
    started: 'Эхэлсэн',
    ends: 'Дуусах',
    remindLabel: 'Хугацаа дуусахаас 3 хоногийн өмнө сануулах',
    remindHint: 'И-мэйл болон апп мэдэгдлээр',
    usageTitle: 'Эрхийн ашиглалт',
    remainingCount: 'үлдсэн',
    extrasHint:
      'Дээрх 2 тохиргоог сонгоод хадгалснаар идэвхжинэ. Нэг удаа хадгалах боломжтой.',
    extrasLockedHint: 'Өөрчилсний дараа хадгална уу.',
    extrasSaveSuccess: 'Тохиргоо амжилттай хадгаллаа',
    save: 'Хадгалах',
    historyTitle: 'Худалдан авалтын түүх',
    viewAll: 'Бүгдийг харах',
    historyPurchased: 'Худалдан авсан',
    historyPackage: 'Багц',
    historyValid: 'Хүчинтэй хугацаа',
    historyPayment: 'Төлбөр',
    historyAmount: 'Дүн',
    historyStatus: 'Төлөв',
    historyEmpty: 'Худалдан авалт олдсонгүй',
    balancePay: 'Хэтэвч',    
    inactiveTitle: 'Zangia Plus',
    inactiveSubtitle:
      'Ажил горилохдоо давуу тал өгөх нэмэлт боломжуудыг идэвхжүүлнэ үү',
  },
  en: {
    quickTitle: 'Become a Plus member',
    noSentOverlayTitle: 'This information is available only to applicants who have applied for the job',
    quickSubtitleBefore:
      'See applicant age, experience, skills, and how your CV fits with ',
    quickSubtitleAfter: '',
    quickSubtitleBrand: 'Zangia Plus',
    overlayTitle: 'This information is available only to Plus users',
    overlaySubtitle:
      'Unlock applicant age, experience, skills, and CV fit with Zangia Plus',
    activate: 'Activate Plus',
    introTitle: 'Meet Zangia Plus',
    introSubtitle: 'Extra advantages for your job search',
    unlimited: 'Unlimited',
    sale: 'Sale',
    monthly: 'Monthly plan',
    quarterly: '3-month plan',
    payTitle: 'Pay',
    insufficientTitle: 'Insufficient balance',
    payAmount: 'Amount due:',
    totalBalance: 'Total balance:',
    remaining: 'Remaining:',
    shortfall: 'Amount due:',
    main: 'Main',
    bonus: 'Bonus',
    cancel: 'Cancel',
    pay: 'Pay',
    recharge: 'Recharge account',
    paySuccess: 'Plus has been activated',
    settingsTitle: 'Zangia Plus membership',
    settingsTab: 'Zangia Plus',
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
    changePackage: 'Change plan',
    extend: 'Renew',
    purchasedOn: 'Purchased on',
    validUntil: 'Valid until',
    validUntilSuffix: '',
    remainingTime: 'Time left',
    remainingDays: 'days',
    ofDays: 'days total',
    endsAt: 'Expires at 23:59',
    started: 'Started',
    ends: 'Ends',
    remindLabel: 'Remind me 3 days before expiry',
    remindHint: 'By email and in-app notification',
    usageTitle: 'Membership usage',
    remainingCount: 'left',
    extrasHint:
      'Select the two options above and save to activate. You can save once.',
    extrasLockedHint: 'Save after you change these options.',
    extrasSaveSuccess: 'Settings saved',
    save: 'Save',
    historyTitle: 'Purchase history',
    viewAll: 'View all',
    historyPurchased: 'Purchased',
    historyPackage: 'Plan',
    historyValid: 'Valid period',
    historyPayment: 'Payment',
    historyAmount: 'Amount',
    historyStatus: 'Status',
    historyEmpty: 'No purchases yet',
    balancePay: 'Wallet',
    inactiveTitle: 'Zangia Plus',
    inactiveSubtitle: 'Activate extra advantages for your job search',
  },
} as const;

export const ZANGIA_PLUS_PRICE_GROUP_ID = 34;

export type PlusPackageId = 1 | 3;

/** API price id — 1 сарын багц (анхдагч сонголт). */
export const DEFAULT_PLUS_PRICE_ID = 1;

export const plusPackages: {
  id: PlusPackageId;
  months: number;
  price: number;
  oldPrice: number | null;
}[] = [
  { id: 1, months: 1, price: 9900, oldPrice: null },
  { id: 3, months: 3, price: 25900, oldPrice: 34700 },
];

export const plusFeatures = [
  {
    id: 'insight',
    included: true,
    unlimited: true,
    count: null,
    mn: 'Ажил горилогчдын 7 төрлийн мэдээлэл харах эрх',
    en: 'View 7 types of applicant insights',
  },
  {
    id: 'fit',
    included: true,
    unlimited: true,
    count: null,
    mn: 'CV болон ажлын зарын зохицол',
    en: 'CV and job fit',
  },
  {
    id: 'career',
    included: true,
    unlimited: false,
    count: 3,
    mn: 'Career зөвлөмж харах эрх',
    en: 'Career recommendations',
  },
  {
    id: 'photo',
    included: true,
    unlimited: false,
    count: 3,
    mn: 'Профайл зураг сайжруулах эрх',
    en: 'Profile photo enhancement',
  },
  {
    id: 'cvAdvice',
    included: true,
    unlimited: false,
    count: 3,
    mn: 'CV зөвлөмж авах эрх',
    en: 'CV advice',
  },
  {
    id: 'cvtop',
    included: false,
    selectable: true,
    unlimited: true,
    count: null,
    mn: 'CV бааз хайлтад дээгүүр жагсах',
    en: 'Rank higher in CV search',
    hintMn: 'Байгууллагууд CV хайхад таны CV эхэнд харагдана',
    hintEn: 'Companies will see your CV first in search',
  },
  {
    id: 'suggesttop',
    included: false,
    selectable: true,
    unlimited: true,
    count: null,
    mn: 'Шинэ ажлын байранд эхэнд санал болгох',
    en: 'Get suggested first for new jobs',
    hintMn: 'Тохирох шинэ зар нийтлэгдмэгц танд түрүүлж мэдэгдэнэ',
    hintEn: 'Get notified first when a matching job is posted',
  },
] as const;

export const plusSelectableFeatureIds = ['cvtop', 'suggesttop'] as const;
export type PlusSelectableFeatureId = (typeof plusSelectableFeatureIds)[number];

export function isPlusSelectableFeatureId(
  id: string
): id is PlusSelectableFeatureId {
  return (plusSelectableFeatureIds as readonly string[]).includes(id);
}
